import { formatInTimeZone } from 'date-fns-tz';

// Default timezone for the application
export const DEFAULT_TIMEZONE = 'America/New_York';

// Helper function to safely format dates in timezone
export const formatDateInTimezone = (date, formatStr = 'yyyy-MM-dd\'T\'HH:mm:ssXXX') => {
  try {
    if (!date) return null;
    
    // Ensure we have a valid date object
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date:', date);
      return null;
    }
    
    return formatInTimeZone(dateObj, DEFAULT_TIMEZONE, formatStr);
  } catch (error) {
    console.error('Error formatting date in timezone:', error);
    return null;
  }
};

// Helper function to format start of day in timezone
export const formatStartOfDay = (date) => {
  try {
    if (!date) return null;
    
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date:', date);
      return null;
    }
    
    // Set to start of day (00:00:00.000)
    dateObj.setHours(0, 0, 0, 0);
    
    return formatInTimeZone(dateObj, DEFAULT_TIMEZONE, 'yyyy-MM-dd\'T\'00:00:00.000XXX');
  } catch (error) {
    console.error('Error formatting start of day:', error);
    return null;
  }
};

// Helper function to format end of day in timezone
export const formatEndOfDay = (date) => {
  try {
    if (!date) return null;
    
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date:', date);
      return null;
    }
    
    // Set to end of day (23:59:59.999)
    dateObj.setHours(23, 59, 59, 999);
    
    return formatInTimeZone(dateObj, DEFAULT_TIMEZONE, 'yyyy-MM-dd\'T\'23:59:59.999XXX');
  } catch (error) {
    console.error('Error formatting end of day:', error);
    return null;
  }
};

// Helper function to format date range for queries
export const getFormattedDateRange = (date) => {
  try {
    if (!date) return { startDate: null, endDate: null };
    
    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date:', date);
      return { startDate: null, endDate: null };
    }
    
    return {
      startDate: formatStartOfDay(dateObj),
      endDate: formatEndOfDay(dateObj)
    };
  } catch (error) {
    console.error('Error formatting date range:', error);
    return { startDate: null, endDate: null };
  }
};